import * as React from "react";
import { forwardRef } from "react";
const SvgRightArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 12, viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.17 7L8.59 10.59L10 12L16 6L10 0L8.59 1.41L12.17 5H0V7H12.17Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgRightArrow);
export { ForwardRef as ReactComponent };
